import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaArrowLeft,
  FaClock,
  FaMapMarkerAlt,
  FaTimes,
} from "react-icons/fa";
import api from "../utils/api";
import "./ComplaintDetail.css";

const ComplaintDetail = ({ type = "complaint" }) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

 

  // Close modal on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setSelectedImage(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const fetchDetails = useCallback(async () => {
    try {
      setLoading(true);

      const endpoint =
        type === "complaint"
          ? `/complaints/${id}`
          : `/requests/${id}`;

      const response = await api.get(endpoint);

      console.log("DETAIL RESPONSE:", response.data);

      const detail =
        response.data.data ||
        response.data.complaint ||
        response.data.request ||
        response.data;

      console.log("Images:", detail.images);

      setData(detail);
    } catch (error) {
      console.error(error);
      toast.error("Failed to load details");
      navigate("/dashboard");
    } finally {
      setLoading(false);
    }
  }, [id, navigate, type]);


   useEffect(() => {
  fetchDetails();
}, [fetchDetails]);

  const getStatusBadge = (status) => (
    <span className={`badge badge-${status}`}>
      {status}
    </span>
  );

  const formatDate = (date) =>
    new Date(date).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  const getImageUrl = (image) => {
    if (!image) return "";

    if (image.startsWith("http")) {
      return image;
    }

    if (image.startsWith("/uploads")) {
      return `http://localhost:8080${image}`;
    }

    return `http://localhost:8080/uploads/${image}`;
  };

  if (loading) {
    return <div className="loading">Loading details...</div>;
  }

  if (!data) {
    return <div className="loading">Not found</div>;
  }

  return (
    <div className="detail-page">
      <div className="detail-container">
        <button
          className="back-btn"
          onClick={() => navigate("/dashboard")}
        >
          <FaArrowLeft /> Back to Dashboard
        </button>

        <div className="detail-header">
          <div>
            <h2>{data.title}</h2>

            <div className="detail-meta">
              <span className="category-badge">
                {data.category?.replace("_", " ")}
              </span>

              {getStatusBadge(data.status)}
            </div>
          </div>
        </div>

        <div className="detail-content">
          <div className="detail-section">
            <h3>Description</h3>

            <p>{data.description}</p>
          </div>

          {data.location?.address && (
            <div className="detail-section">
              <h3>
                <FaMapMarkerAlt /> Location
              </h3>

              <p>{data.location.address}</p>
            </div>
          )}

          {data.images &&
            data.images.length > 0 && (
              <div className="detail-section">
                <h3>Attached Images</h3>

                <div className="detail-images">
                  {data.images.map((image, index) => {
                    const imageUrl =
                      getImageUrl(image);

                    return (
                      <img
                        key={index}
                        src={imageUrl}
                        alt={`Attachment ${
                          index + 1
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          setSelectedImage(imageUrl)
                        }
                        onError={(e) => {
                          console.log(
                            "Image failed:",
                            imageUrl
                          );

                          e.target.style.display =
                            "none";
                        }}
                      />
                    );
                  })}
                </div>
              </div>
            )}

          <div className="detail-section">
            <h3>
              <FaClock /> Timeline
            </h3>

            <div className="timeline">
              {data.statusHistory?.map(
                (history, index) => (
                  <div
                    key={index}
                    className="timeline-item"
                  >
                    <div className="timeline-marker"></div>

                    <div className="timeline-content">
                      <div className="timeline-status">
                        {getStatusBadge(
                          history.status
                        )}
                      </div>

                      <div className="timeline-date">
                        {formatDate(
                          history.updatedAt
                        )}
                      </div>

                      {history.comment && (
                        <p>{history.comment}</p>
                      )}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>

          {data.followUps &&
            data.followUps.length > 0 && (
              <div className="detail-section">
                <h3>
                  Follow-ups (
                  {data.followUps.length})
                </h3>

                <div className="followups-list">
                  {data.followUps.map(
                    (followUp, index) => (
                      <div
                        key={index}
                        className="followup-item"
                      >
                        <div className="followup-date">
                          {formatDate(
                            followUp.sentAt
                          )}
                        </div>

                        <p>
                          {followUp.message}
                        </p>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

          <div className="detail-footer-actions">
            <button
              type="button"
              className="btn btn-back-dashboard"
              onClick={() => navigate("/dashboard")}
            >
              <FaArrowLeft /> Back to Dashboard
            </button>
          </div>
        </div>
      </div>

      {/* Image Lightbox Modal */}
      {selectedImage && (
        <div
          className="image-modal-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <button
            className="image-modal-close"
            onClick={() => setSelectedImage(null)}
            aria-label="Close image preview"
          >
            <FaTimes />
          </button>

          <img
            src={selectedImage}
            alt="Full size attachment"
            className="image-modal-content"
            onClick={(e) => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default ComplaintDetail;